/* ================================================== */
/* UTILS → ratio
/* ================================================== */

function ratio() {
	$('.js-ratio').each(function(i) {
		$(this).height(Math.ceil($(this).width() * $(this).attr('data-ratio')));
	});
}

$(window).resize(function() {
	ratio();
});

document.addEventListener('webkitfullscreenchange', function() {
	ratio();
}, false);

window.onorientationchange = function() {
	var orientation = window.orientation;
	ratio();
}